import './ModuleDetailsDescription.scss';
import Subtitle from 'components/TextComps/Subtitle';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';

type ModuleDetailsDescriptionProps = {
  description: string;
};

export const ModuleDetailsDescription = ({ description }: ModuleDetailsDescriptionProps) => {
  const { t } = useTranslation();
  return (
    <section className='description'>
      <Subtitle>
        <>{t('ModuleDescription', { ns: 'learningHub' })}</>
      </Subtitle>
      <Paragraph className='content'>
        <>{description}</>
      </Paragraph>
    </section>
  );
};
